import Vue from 'vue';
import Router, { RouteRecord, RouteConfig } from 'vue-router';

import Foyer from '../views/Foyer.vue';

Vue.use(Router);

const routes: RouteConfig[] = [
  {
    path: '/foyer/:appointment/:client?',
    name: 'foyer',
    component: Foyer
  }
];

const router = new Router({
  mode: 'history',
  routes
});

export default router;
